import type { FiltekProduct } from '../types/filtek'
import { brand } from './palette'

export const products: FiltekProduct[] = [
  {
    id: 'supreme-ultra',
    name: 'Filtek Supreme Ultra Universal Restorative',
    shortName: 'Supreme Ultra',
    descriptor: 'Nanocomposite for layered, high-demand aesthetics',
    form: 'sculptable',
    accent: brand.mint,
    claim: 'Full control over shade, opacity and translucency — layer by layer.',
    facts: [
      { label: 'Shade system', value: '36 shades, 4 opacities' },
      { label: 'Filler', value: 'Nanofiller technology' },
      { label: 'Built for', value: 'Anterior layering, complex aesthetics' },
      { label: 'Finish', value: 'High initial gloss, polish retention' }
    ]
  },
  {
    id: 'easy-match',
    name: 'Filtek Easy Match Universal Restorative',
    shortName: 'Easy Match',
    descriptor: 'Three shade options for everyday restorations',
    form: 'sculptable',
    accent: brand.green,
    claim: 'Three options cover the everyday shade range. The puzzle disappears.',
    facts: [
      { label: 'Shade system', value: '3 options: Light, Medium, Dark' },
      { label: 'Chairside effect', value: 'Blends to surrounding tooth structure' },
      { label: 'Built for', value: 'Single-shade everyday restorations' },
      { label: 'Inventory', value: 'Fewer shades to stock and decide between' }
    ]
  },
  {
    id: 'universal',
    name: 'Filtek Universal Restorative',
    shortName: 'Universal',
    descriptor: 'One material across anterior and posterior',
    form: 'sculptable',
    accent: brand.lime,
    claim: 'Eight shades that cover the cases you see every day, front and back.',
    facts: [
      { label: 'Shade system', value: '8 shades cover 19 VITA shades' },
      { label: 'Handling', value: 'Non-slump, sculpts and holds' },
      { label: 'Built for', value: 'Everyday anterior and posterior work' },
      { label: 'Finish', value: 'Fast polish, natural fluorescence' }
    ]
  },
  {
    id: 'one-bulk',
    name: 'Filtek One Bulk Fill Restorative',
    shortName: 'One Bulk Fill',
    descriptor: 'Sculptable posterior bulk fill',
    form: 'bulk',
    accent: brand.emerald,
    claim: 'Fill, sculpt, cure. One increment up to 5 mm.',
    facts: [
      { label: 'Increment', value: 'Up to 5 mm, single placement' },
      { label: 'Stress', value: 'Low polymerisation shrinkage stress' },
      { label: 'Built for', value: 'Class I and II posterior restorations' },
      { label: 'Steps saved', value: 'No capping layer required' }
    ]
  },
  {
    id: 'bulk-flow',
    name: 'Filtek Bulk Fill Flowable Restorative',
    shortName: 'Bulk Fill Flowable',
    descriptor: 'Self-levelling base and liner',
    form: 'flowable',
    accent: brand.aqua,
    claim: 'Flows into the places an instrument cannot reach, then stays put.',
    facts: [
      { label: 'Increment', value: 'Up to 4 mm as a base' },
      { label: 'Adaptation', value: 'Self-levelling, void-reducing' },
      { label: 'Built for', value: 'Deep boxes, liners, tunnel access' },
      { label: 'Pairs with', value: 'One Bulk Fill or Universal capping' }
    ]
  },
  {
    id: 'supreme-flow',
    name: 'Filtek Supreme Flowable Restorative',
    shortName: 'Supreme Flowable',
    descriptor: 'Precise flow for small restorations',
    form: 'flowable',
    accent: brand.aqua,
    claim: 'Controlled placement where the cavity is small and the access is tight.',
    facts: [
      { label: 'Placement', value: 'Precision tip, controlled spread' },
      { label: 'Built for', value: 'Class V, pits, small conservative preps' },
      { label: 'Finish', value: 'Polishable, shade-matched to the family' },
      { label: 'Handling', value: 'Flows on demand, holds on stop' }
    ]
  }
]

export const productById = (id: string): FiltekProduct =>
  products.find((product) => product.id === id) ?? products[0]
